var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fragment",
    class: {
      'focus-prop': _vm.focusProp, 'focus-from': _vm.focusFrom, 'fragment--advanced': _vm.advanced
    }
  }, [_c('header', [_c('h1', {
    staticClass: "fragment-h1"
  }, [_c('textarea-subtle', {
    attrs: {
      "placeholder": _vm.fragment['@id'] || 'Fatal error'
    },
    model: {
      value: (_vm.fragment['schema:name']),
      callback: function($$v) {
        _vm.$set(_vm.fragment, 'schema:name', $$v)
      },
      expression: "fragment['schema:name']"
    }
  }), _vm._v(" "), _c('input-class', {
    attrs: {
      "placeholder": "wut"
    },
    model: {
      value: (_vm.fragment['@type']),
      callback: function($$v) {
        _vm.$set(_vm.fragment, '@type', $$v)
      },
      expression: "fragment['@type']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fragment-json mdi mdi-12px mdi-code-braces",
    on: {
      "mouseenter": function($event) {
        _vm.advanced = 1
      },
      "mouseleave": function($event) {
        _vm.advanced = 0
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.advanced) ? _c('div', [_c('form', {
    on: {
      "submit": _vm.copy
    }
  }, [_vm._v("\n            Copy fragment to:\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyURI),
      expression: "copyURI"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.copyURI)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.copyURI = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Copy")])]), _vm._v(" "), _c('form', {
    on: {
      "click": function($event) {
        _vm.$root.fetch(_vm.fragment['@id'], true)
      }
    }
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("refetch " + _vm._s(_vm.fragment['@id']))])]), _vm._v(" "), _c('pre', {
    staticClass: "fragment-pre"
  }, [_vm._v(_vm._s(_vm.fragment))]), _vm._v(" "), _c('input-raw', {
    model: {
      value: (_vm.fragment),
      callback: function($$v) {
        _vm.fragment = $$v
      },
      expression: "fragment"
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('article', [(_vm.$root.show.json) ? _c('input-raw', {
    model: {
      value: (_vm.fragment),
      callback: function($$v) {
        _vm.fragment = $$v
      },
      expression: "fragment"
    }
  }) : _vm._e(), _vm._v(" "), _c('props-list', {
    attrs: {
      "fragment": _vm.fragment
    }
  })], 1), _vm._v(" "), _c('nav', {
    staticClass: "fragment__nav"
  }, [_c('div', {
    staticClass: "nav-right"
  }, [_c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.showURI = !_vm.$root.showURI
      }
    }
  }, [_vm._v("URI")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.copyFragment(_vm.fragment['@id'])
      }
    }
  }, [_vm._v("Duplicate")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.show.json = !_vm.$root.show.json
      }
    }
  }, [_vm._v("JSON")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.sync(_vm.fragment['@id'])
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.discard(_vm.fragment['@id'])
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _vm._l((_vm.capabilities), function(c) {
    return _c('button', {
      staticClass: "btn btn-soft app-nav__uri",
      attrs: {
        "type": "button"
      },
      on: {
        "click": c.click
      }
    }, [_vm._v(_vm._s(c.label || c.type || '*'))])
  })], 2)]), _vm._v(" "), (_vm.loadPlugin(_vm.fragment) && _vm.resolved) ? _c(_vm.loadPlugin(_vm.fragment), {
    tag: "div",
    attrs: {
      "a": _vm.resolved,
      "options": _vm.options
    }
  }, [_vm._v("test")]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb9449e2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fragment.vue
// module id = 95
// module chunks = 1